import * as React from "react";
import {
  Grid,
  withStyles,
  CssBaseline,
  createMuiTheme,
  MuiThemeProvider,
  Snackbar,
  Button,
  CircularProgress,
} from "@material-ui/core";
import LeftSideMenuController from "modules/project/components/layouts/LeftSideMenuController";
import ToolBarCostPlan from "modules/project/components/layouts/ToolBarCostPlan";
import ToolBarTask from "modules/project/components/layouts/ToolBarTask";
import ToolBarTakeOffFormat from "modules/project/components/layouts/ToolBarTakeOffFormat";
import RightSideMenu from "modules/projectRightMenu/components/pages/ProjectRightMenu";
import ProjectTheme from "modules/project/components/pages/ProjectTheme";
import Content from "modules/project/components/layouts/Content";
import { Switch, Route } from "react-router-dom";
import { DevelopmentStore } from "modules/development/DevelopmentStore";
import { SnackbarProvider } from "notistack";
import { WBSStore } from "modules/WBS/WBSStore";
import { TakeOffStore } from "modules/takeOff/TakeOffStore";
import { observer } from "mobx-react";
import { ProjectStore } from "modules/project/ProjectStore";
import i18n from "i18n";
import { ModelMapStore } from "modules/modelMap/ModelMapStore";
import { Render3dStore } from "modules/render3D/Render3dStore";
import { ToolbarStore } from "modules/WBS/ToolbarStore";
import { ToolbarTaskStore } from "modules/WBS/ToolbarTaskStore";
import { LibraryStore } from "modules/library/LibraryStore";
import { ActivitySearchStore } from "modules/activitySearch/ActivitySearchStore";
import LayerExport from "modules/costPlan/components/layouts/LayerExport";
import { LoginStore } from "modules/login/LoginStore";
import TrialBanner from "../layouts/TrialBanner";
import SubscribeNowCard from "modules/development/components/layouts/SubscribeNowCard";

const theme = createMuiTheme(ProjectTheme);

const styles = (theme) => ({
  container: {
    height: "100vh",
    width: "100vw",
    display: "grid",
    minWidth: "1024px",
  },
  name: {
    fontFamily: "Roboto",
    fontSize: "12px",
    fontWeight: 500,
    color: "#fff",
    backgroundColor: "#000",
    lineHeight: "33px",
    paddingLeft: "10px",
  },
  middle: {
    display: "grid",
    gridTemplateRows: "auto 1fr",
  },
  loadContainer: {
    display: "flex",
    alignItems: "center",
  },
  wrapper: {
    margin: "0 auto",
    position: "relative" as any,
  },
});

type IProps = {
  classes: any;
  match: any;
};

@observer
class Project extends React.Component<IProps> {
  state = {
    loaded: false,
  };

  componentDidMount() {
    this.setDevelopmentSelected();
  }

  componentWillUnmount() {
    WBSStore.reset();
    DevelopmentStore.developmentSelected = undefined as any;
    document.title = "Rubk";

    TakeOffStore.resetStore();
    ModelMapStore.resetStore();
    Render3dStore.resetStore();
    ToolbarStore.resetStore();
    ToolbarTaskStore.resetStore();
    ProjectStore.resetStore();
    LibraryStore.resetStore(true);
    ActivitySearchStore.resetStore();
  }

  setDevelopmentSelected = async () => {
    this.setState({ loaded: true });
    if (DevelopmentStore.developmentSelected)
      document.title = `Rubk - ${DevelopmentStore.developmentSelected.data.name}`;
  };

  handleCloseSnack = () => {
    ProjectStore.showSnackMessage("", "");
  };

  render() {
    const {
        state: { loaded },
        props: { classes },
      } = this,
      { developmentSelected } = DevelopmentStore,
      { task } = WBSStore;

    const gridCol = { gridTemplateRows: "35px auto" };

    return developmentSelected ? (
      <>
        <SnackbarProvider
          maxSnack={3}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transitionDuration={{ exit: 380, enter: 400 }}
        >
          <React.Fragment>
            <SubscribeNowCard />
            <MuiThemeProvider theme={theme}>
              <CssBaseline />
              {loaded && (
                <>
                  <div
                    id="NovoID"
                    className={classes.container}
                    style={LoginStore.isTrialUser() ? gridCol : {}}
                  >
                    <TrialBanner />
                    <div
                      style={{
                        gridTemplateColumns: "auto 4fr 250px",
                        display: "grid",
                        overflow: "hidden",
                      }}
                    >
                      <LeftSideMenuController />
                      <div className={classes.middle}>
                        {
                          /** Impede que o sistema reconstrua todos os componentes abaixo ao alterar
                           * uma linha da EAP.
                           * TODO - Quando houver tempo, o melhor para performance é alterar para o
                           * loading para sobrepor os componentes no else e não destruí-los.
                           */
                          ProjectStore.canLoadingOnContent &&
                          WBSStore.loadingItens !== false ? (
                            <div className={classes.loadContainer}>
                              <div className={classes.wrapper}>
                                <div
                                  style={{
                                    width: "100%",
                                    height: "calc(100vh) / 2",
                                    marginTop: "calc((100vh - 80px) / 2)",
                                    textAlign: "center",
                                  }}
                                >
                                  <span
                                    style={{
                                      position: "absolute",
                                      left: "calc(50% - 300px)",
                                      color: "#ABC200",
                                      width: "600px",
                                      top: "calc(calc(100vh / 2) + 60px)",
                                    }}
                                  >
                                    {i18n.wbs.loading}
                                  </span>
                                  <CircularProgress
                                    size={90}
                                    variant="indeterminate"
                                    style={{ color: "#ABC200", zIndex: 100 }}
                                  />
                                </div>
                              </div>
                            </div>
                          ) : (
                            <>
                              <Grid container>
                                <Grid item xs={3} className={classes.name}>
                                  {developmentSelected &&
                                    developmentSelected.data.name}
                                </Grid>
                                <Grid
                                  item
                                  xs={9}
                                  style={{ backgroundColor: "#000" }}
                                >
                                  {TakeOffStore.layerTakeOffList ? (
                                    <ToolBarTakeOffFormat />
                                  ) : (
                                    <Switch>
                                      <Route
                                        path={`/${developmentSelected.id}/WBS`}
                                        component={
                                          task ? ToolBarTask : ToolBarCostPlan
                                        }
                                      />
                                      <Route
                                        path={`/${developmentSelected.id}/viewer`}
                                        component={ToolBarCostPlan}
                                      />
                                    </Switch>
                                  )}
                                </Grid>
                              </Grid>
                              <Content />
                            </>
                          )
                        }
                      </div>
                      <RightSideMenu />
                    </div>
                  </div>
                </>
              )}
            </MuiThemeProvider>
            <LayerExport />
            <Snackbar
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              open={Boolean(ProjectStore.showSnack)}
              onClose={this.handleCloseSnack}
              ContentProps={{
                "aria-describedby": "message-id",
              }}
              message={
                ProjectStore.snackSecondMessage !== "" ? (
                  <span>
                    {" "}
                    {ProjectStore.showSnack} <br />{" "}
                    {ProjectStore.snackSecondMessage}{" "}
                  </span>
                ) : (
                  ProjectStore.showSnack
                )
              }
              action={[
                <Button
                  key="undo"
                  color="primary"
                  size="small"
                  onClick={this.handleCloseSnack}
                >
                  {i18n.gotIt}
                </Button>,
              ]}
            />
          </React.Fragment>
        </SnackbarProvider>
      </>
    ) : (
      <></>
    );
  }
}
export default withStyles(styles)(Project);



// WEBPACK FOOTER //
// ./src/modules/project/components/pages/Project.tsx